import { theme } from '@dojo/framework/core/middleware/theme';
import { create, v, w } from '@dojo/framework/core/vdom';
import { createNlsMiddleware } from '@holmescorp/lcc-state';
import { publish } from '@holmescorp/pub-sub';
import css from '../css/index.m.css';
import ContentContainer from './container';
import MicroToolsButton from './tools-button';
const factory = create({
    settings: createNlsMiddleware('settings'),
    ditabook: createNlsMiddleware('ditabook'),
    theme
}).properties();
export const LearnerTools = factory(({ id: widgetId, properties, middleware: { theme, settings, ditabook } }) => {
    const { toolsContainer, tools, toolsList, quizButton } = theme.classes(css);
    const { classes = [], includeQuizButton = true } = properties();
    const { messages: { learnerTools = 'Learner Tools' } } = settings();
    const { messages: { micro_final_quiz_label = 'Take Final Test' } } = ditabook();
    const id = 'learner-tools';
    const key = `${id}-${widgetId}`;
    const xqa = `${id}-widget`;
    return [
        w(ContentContainer, { id, key, xqa, additionalClasses: [toolsContainer] }, [
            v('div', { xqa: `${id}-tools`, classes: [theme.variant(), tools, ...classes] }, [
                v('h3', {}, [learnerTools]),
                v('ul', { classes: [toolsList] }, [
                    v('li', {}, [
                        w(MicroToolsButton, {
                            labelText: 'Glossary',
                            onClick: () => publish('site/glossary')
                        })
                    ]),
                    v('li', {}, [
                        w(MicroToolsButton, {
                            labelText: 'Resource Center',
                            onClick: () => publish('rcs/view/common/rc')
                        })
                    ])
                ])
            ])
        ]),
        includeQuizButton
            ? v('div', { classes: [quizButton] }, [
                w(MicroToolsButton, {
                    labelText: micro_final_quiz_label,
                    darkMode: true,
                    onClick: () => {
                        publish('site/final-test');
                    }
                })
            ])
            : null
    ];
});
export default LearnerTools;
